import type { CellContext } from '@tanstack/angular-table';

/**
 * Cell renderer for a to-ONE relation column: '—' only when the relation object itself is missing
 * (a dangling FK, or a relation the query never asked for); a resolved relation with a legitimately
 * empty displayed field still renders empty. Shared across every module declaring a `relation:
 * { association }` column (T-4.3) — first established ad hoc in supplier-document.columns.ts (T-17).
 */
export function relationCell<T, K extends keyof T>(
  relation: K,
): (info: CellContext<T, unknown>) => string {
  return (info) => (info.row.original[relation] == null ? '—' : (info.getValue<string>() ?? ''));
}
